/**
 * Step 1 of Phone OTP login — collects the +91 mobile number.
 * Pure UI; all state owned by parent / hook.
 */
export default function PhoneStep({ phone, setPhone, err, loading, onSubmit }) {
  return (
    <form
      onSubmit={(e) => { e.preventDefault(); onSubmit(); }}
      className="space-y-4"
    >
      <label className="block">
        <span className="eyebrow block mb-2">India mobile number</span>
        <div className="flex items-stretch border hairline">
          <span className="px-3 flex items-center bg-[hsl(var(--muted))] text-sm text-muted-foreground">+91</span>
          <input
            type="tel"
            inputMode="numeric"
            autoFocus
            maxLength={10}
            value={phone}
            onChange={(ev) => setPhone(ev.target.value.replace(/\D/g, ""))}
            placeholder="9876543210"
            className="input-dark flex-1 px-3 py-2.5 text-base border-0"
            data-testid="phone-otp-phone-input"
          />
        </div>
        <small className="text-xs text-muted-foreground mt-1 block">10-digit number. Standard SMS rates apply.</small>
      </label>
      {err && <div className="text-sm text-destructive" data-testid="phone-otp-error">{err}</div>}
      <button
        type="submit"
        disabled={loading || phone.length !== 10}
        className="btn-primary w-full py-3 text-sm"
        data-testid="phone-otp-send-btn"
      >
        {loading ? "Sending OTP…" : "Send OTP"}
      </button>
    </form>
  );
}
